import constant from '../../constant'

const initialState = { 
  sysDialogStatus: false, // 系统体验弹窗
  welfareDialogStatus: false, // 福利弹窗
  sysDialogActiveAppStatus: false, // 拉新激活弹窗
  cancelInstallWelfareDialogStatus: false,
  cancelInstallDefaultDialogStatus: false,
  smpDialogStatus: false, // smp 弹窗状态
  cancel: null,
  primary: null,

  contentCollapsed: {
    collapsed: true,
    maxContentHeight: ''
  }
};

export function dialog (state = initialState, action) {
  switch (action.type) {
    case constant.DIALOG.SYS_DIALOG:
      return {
        ...state,
        ...action
      }
    case constant.DIALOG.SMP_DIALOG:
      return {
        ...state,
        ...action
      }
    case constant.DIALOG.WELFARE_DIALOG:
      return {
        ...state,
        welfareDialogStatus: action.welfareDialogStatus
      }
    case constant.DIALOG.SYS_DIALOG_ACTIVE_APP:
      return {
        ...state,
        sysDialogActiveAppStatus: action.sysDialogActiveAppStatus
      }
    case constant.DIALOG.COLLAPSED:
      return {
        ...state,
        contentCollapsed: action.contentCollapsed
      }
    case constant.DIALOG.CANCEL_INSTALL_DIALOG:
      return {
        ...state,
        cancelInstallWelfareDialogStatus: action.cancelInstallWelfareDialogStatus,
        cancelInstallDefaultDialogStatus: action.cancelInstallDefaultDialogStatus
      }
    default:
      return state
  }
}